
import SceneKeys from "~/consts/SceneKeys";
import RoundRectangle from 'phaser3-rex-plugins/plugins/roundrectangle.js';
import { Sizer } from 'phaser3-rex-plugins/templates/ui/ui-components.js';
import { PlayGame } from "./PlayGame";
import { Label } from 'phaser3-rex-plugins/templates/ui/ui-components.js';
import { GlobalConfig } from "~/config/GlobalConfig";
import IconKey from "~/consts/IconKey";
import { GridSizer } from 'phaser3-rex-plugins/templates/ui/ui-components.js';
import TextureKeys from "~/consts/TextureKeys";
import { RTPManager } from "~/consts/RTPManager";
import { RockyRoller } from "./RockyRoller";
import { Rectangle } from "phaser3-rex-plugins/plugins/gameobjects/shape/shapes/geoms";
import GameManager from "./GameManager";


export default class UI extends Phaser.Scene {
    // top bar ui ref

    gameScene !:GameManager;
    allButtons;
    txtPlusMinusAmount;
    txtGreenBet;
    txtBetxGreen;
    txtMoney;
    fakePlayerList;
    coinHave!: number;
    betAmount!: number;
    txtShowBetx;
    autoplayBtn;
    grid;
    firstStart:boolean
    lastWinTxt;
    gameSt;
    playAginBtn;
    totalBet;
    firstBet;
    startBet;
    maxBet;
    constructor() {
        super(SceneKeys.UIScene)
        this.firstStart=true;
    }
    create() {
        const bg1=this.add.image(0,0,TextureKeys.BG).setDepth(-2).setOrigin(0,0);
        bg1.setDisplaySize(bg1.width*GlobalConfig.SIZE_MULTI,bg1.height*GlobalConfig.SIZE_MULTI)
        const bgOver=this.add.rectangle(0,0,bg1.width,bg1.height,GlobalConfig.BACKGROUND_COLOR).setDepth(-1).setOrigin(0,0);
        bgOver.alpha=0.6;
        this.fakePlayerList = [];
        this.allButtons = [];
        this.betAmount = 0;
        this.scene.launch(SceneKeys.PokerScene);
        this.gameScene = this.scene.get(SceneKeys.PokerScene) as GameManager;
        this.coinHave = this.getUSD();
        this.gameSt=false;
        this.totalBet=0;
        this.startBet=0;
        // this.setTopBar();
        // console.log(this.firstStart)
        if (this.lastWin() >= 0) {
            this.lastWinTxt?.setText(`LAST WIN USD ${this.lastWin().toFixed(2)}`)
        }
        
        // if (this.firstStart) {
        //     this.firstStart = false;
        //     this.setBottomPart2()
        //     // this.BetGrid()
        // }
        // else
        {
            // this.deductCoinAndStart(0)
        }
        this.setBottomPart2()
        // this.gameScene.SetGameUI()
        this.firstBet=false;
        const logo =this.add.image(50,30,TextureKeys.Logo).setOrigin(0,0)
        logo.setDisplaySize(logo.width*GlobalConfig.SIZE_MULTI,logo.height*GlobalConfig.SIZE_MULTI);
        this.setUSDTopBar();
    }


    public deductCoinAndStart(am:number)
    {
        this.coinHave-=am;
        this.setUSDTopBar()
        this.setUSD()
        this.grid?.hide()
        this.setBottomPart2()
        this.gameScene.SetGameUI()
    }

    public BetGrid()
    {
        this.grid = new GridSizer(this, {
            x: this.cameras.main.width / 2,
            y: this.cameras.main.height / 2+20,
            column: 3,
            row: 2,
            space: { column: 30, row: 30 } 
        });

        const btn1 = this.createStartBet(`$1`)
        btn1.setInteractive().on('pointerdown',
            () => {
                this.deductCoinAndStart(1)
            });
        this.grid.add(btn1, { column: 0, row: 0,   });

        const btn2 = this.createStartBet(`$2`);
        btn2.setInteractive().on('pointerdown',
            () => {
                this.deductCoinAndStart(2)
            });
        this.grid.add(btn2, { column: 1, row: 0,   });

        const btn3 = this.createStartBet(`$5`);
        btn3.setInteractive().on('pointerdown',
            () => {
                this.deductCoinAndStart(5)
            });
        this.grid.add(btn3, { column: 2, row: 0,   });

        const btn4 = this.createStartBet(`$10`);
        btn4.setInteractive().on('pointerdown',
            () => {
                this.deductCoinAndStart(10)
            });
        this.grid.add(btn4, { column: 0, row: 1,   });

        const btn5 = this.createStartBet(`$50`);
        btn5.setInteractive().on('pointerdown',
            () => {
                this.deductCoinAndStart(50)
            });
        this.grid.add(btn5, { column: 1, row: 1,   });

        const btn6 = this.createStartBet(`$100`);
        btn6.setInteractive().on('pointerdown',
            () => {
                this.deductCoinAndStart(100)
            });
        this.grid.add(btn6, { column: 2, row: 1,   });

        this.grid.layout();
    }

    createStartBet(txt:string)
    {
        // Create a RoundRectangle button with a label
        const button = new RoundRectangle(this, 0, 0, 120, 150, 20, GlobalConfig.SECONDARY_COLOR); // Green color
        this.add.existing(button);

        const label = this.add.text(0, 0, txt, {
            fontFamily:GlobalConfig.FONT_FAMILY,
            fontSize: GlobalConfig.FONT_SIZE_TITLE,
            color: '#'+GlobalConfig.FONT_COLOR.toString(16)
        }).setOrigin(0.5);

        // Combine the button and label into a container for positioning within the grid
        const container = this.add.container(0, 0, [button, label]);
        container.setSize(120, 150)
        return container;
    }

    public showBetTxt(bet : number)
    {
        this.txtShowBetx.setText(bet.toFixed(3) +"X")
    }
    restartGame() {
        this.scene.stop(SceneKeys.PokerScene);
        this.scene.stop(SceneKeys.UIScene);
        this.scene.start(SceneKeys.Preloader);
    }

    public gameOver(betx:number)
    {

        this.gameScene.txtWin.setText("You Win $"+ (betx*this.betAmount).toFixed(2))
        this.coinHave+=betx*this.betAmount;
        this.setLastWin((betx*this.betAmount))
       this.setUSD()
       this.playAginBtn.setVisible(true)
        // this.restartGame()
        // this.cameras.main.shake(1500, 0.005, false, this.overUi);
    }

    public over()
    {
        this.cameras.main.shake(1500, 0.005, false, this.overUi);
    }
    public cashOutWin(betx : number)
    {
        this.coinHave+=betx*this.betAmount;
        this.setLastWin((betx*this.betAmount))
       this.setUSD()
    }

    

    overUi(cam = null, progress = 0)
    {
        if(progress==1)
        {
            this.restartGame()
        }
    }
    disableButtons() {
        //console.log(this.allButtons.length)
        this.allButtons.forEach(button => {
            button.disableInteractive();
            if (button instanceof Phaser.GameObjects.Image) {
                button.setTint(GlobalConfig.BUTTON_TINT);
            } else if (button instanceof Phaser.GameObjects.Rectangle) {
                button.setFillStyle(GlobalConfig.RECT_TINT);
            }
        });
    }
    
    // Botton Buttons
    // setBottomPart() {
    //     // add button opart
    //     var enterRect = new RoundRectangle(this, this.cameras.main.width - 100, this.cameras.main.height - 30,
    //         170, 100,
    //         25,
    //         GlobalConfig.SECONDARY_COLOR)
    //         .setOrigin(1, 1);
    //     this.add.existing(enterRect);
    //     var bgPlusMinus = this.add.rectangle(
    //         enterRect.x - (enterRect.width / 2),
    //         enterRect.y - (enterRect.height / 2) - 20,
    //         100, 20, GlobalConfig.BACKGROUND_COLOR);

    //     this.txtPlusMinusAmount = this.add.text(
    //         bgPlusMinus.x,//-(bgPlusMinus.width/2),
    //         bgPlusMinus.y,//-(bgPlusMinus.height/2),
    //         '1', {
    //         fontSize: GlobalConfig.FONT_SIZE_NORMAL,
    //         fontFamily: GlobalConfig.FONT_FAMILY,
    //         align: 'center',
    //         wordWrap: { width: 40 },
    //         color: "#" + GlobalConfig.FONT_COLOR.toString(16)
    //     }).setOrigin(0.5, 0.5);

    //     //
    //     var add = this.add.image(
    //         bgPlusMinus.x + 35,//-(bgPlusMinus.width/2),
    //         bgPlusMinus.y,//-(bgPlusMinus.height/2),
    //         IconKey.add,

    //     ).setDisplaySize(15, 15).setOrigin(0.5, 0.5).setInteractive().on('pointerdown',
    //         () => {
    //             add.setTint(GlobalConfig.BUTTON_TINT)
    //             this.addUSD(1)
    //         });
    //     add.on('pointerup',
    //         () => {
    //             add.clearTint();
    //         }
    //     )
    //     //
    //     var minus = this.add.image(
    //         bgPlusMinus.x - 35,//-(bgPlusMinus.width/2),
    //         bgPlusMinus.y,//-(bgPlusMinus.height/2),
    //         IconKey.minus,
    //     ).setDisplaySize(15, 15).setOrigin(0.5, 0.5).setInteractive().on('pointerdown',
    //         () => {
    //             minus.setTint(GlobalConfig.BUTTON_TINT)
    //             this.addUSD(-1)
    //         });
    //     minus.on('pointerup',
    //         () => {
    //             minus.clearTint();
    //         }
    //     )
    //     this.allButtons.push(add)
    //     this.allButtons.push(minus)
    //     var add1 = this.add.rectangle(
    //         enterRect.x - (enterRect.width / 2) - 30,
    //         enterRect.y - (enterRect.height / 2) + 8,
    //         48, 15, GlobalConfig.BACKGROUND_COLOR).setInteractive().on('pointerdown',
    //             () => {
    //                 add1.setFillStyle(GlobalConfig.RECT_TINT)
    //                 this.addUSD(1)
    //             });
    //     add1.on('pointerup',
    //         () => {
    //             add1.setFillStyle(GlobalConfig.BACKGROUND_COLOR);
    //         }
    //     )
    //     this.allButtons.push(add1)

    //     this.add.text(
    //         add1.x,//-(bgPlusMinus.width/2),
    //         add1.y,//-(bgPlusMinus.height/2),
    //         '1', {
    //         fontSize: GlobalConfig.FONT_SIZE_NORMAL,
    //         fontFamily: GlobalConfig.FONT_FAMILY,
    //         align: 'center',
    //         color: "#" + GlobalConfig.FONT_COLOR.toString(16)
    //     }).setOrigin(0.5, 0.5);
    //     var add2 = this.add.rectangle(
    //         enterRect.x - (enterRect.width / 2) + 30,
    //         enterRect.y - (enterRect.height / 2) + 8,
    //         48, 15, GlobalConfig.BACKGROUND_COLOR).setInteractive().on('pointerdown',
    //             () => {
    //                 add2.setFillStyle(GlobalConfig.RECT_TINT)
    //                 this.addUSD(2)
    //             });
    //     add2.on('pointerup',
    //         () => {
    //             add2.setFillStyle(GlobalConfig.BACKGROUND_COLOR);
    //         }
    //     )
    //     this.allButtons.push(add2)

    //     this.add.text(
    //         add2.x,//-(bgPlusMinus.width/2),
    //         add2.y,//-(bgPlusMinus.height/2),
    //         '2', {
    //         fontSize: GlobalConfig.FONT_SIZE_NORMAL,
    //         fontFamily: GlobalConfig.FONT_FAMILY,
    //         align: 'center',
    //         color: "#" + GlobalConfig.FONT_COLOR.toString(16)
    //     }).setOrigin(0.5, 0.5);

    //     var add5 = this.add.rectangle(
    //         enterRect.x - (enterRect.width / 2) - 30,
    //         enterRect.y - (enterRect.height / 2) + 30,
    //         48, 15, GlobalConfig.BACKGROUND_COLOR).setInteractive().on('pointerdown',
    //             () => {
    //                 add5.setFillStyle(GlobalConfig.RECT_TINT)
    //                 this.addUSD(5)
    //             });
    //     add5.on('pointerup',
    //         () => {
    //             add5.setFillStyle(GlobalConfig.BACKGROUND_COLOR);
    //         }
    //     )
    //     this.allButtons.push(add5)


    //     this.add.text(
    //         add5.x,//-(bgPlusMinus.width/2),
    //         add5.y,//-(bgPlusMinus.height/2),
    //         '5', {
    //         fontSize: GlobalConfig.FONT_SIZE_NORMAL,
    //         fontFamily: GlobalConfig.FONT_FAMILY,
    //         align: 'center',
    //         color: "#" + GlobalConfig.FONT_COLOR.toString(16)
    //     }).setOrigin(0.5, 0.5);
    //     var add10 = this.add.rectangle(
    //         enterRect.x - (enterRect.width / 2) + 30,
    //         enterRect.y - (enterRect.height / 2) + 30,
    //         48, 15, GlobalConfig.BACKGROUND_COLOR).setInteractive().on('pointerdown',
    //             () => {
    //                 add10.setFillStyle(GlobalConfig.RECT_TINT)
    //                 this.addUSD(10)
    //             });
    //     this.allButtons.push(add10)
    //     add10.on('pointerup',
    //         () => {
    //             add10.setFillStyle(GlobalConfig.BACKGROUND_COLOR);
    //         }
    //     )
    //     this.add.text(
    //         add10.x,//-(bgPlusMinus.width/2),
    //         add10.y,//-(bgPlusMinus.height/2),
    //         '10', {
    //         fontSize: GlobalConfig.FONT_SIZE_NORMAL,
    //         fontFamily: GlobalConfig.FONT_FAMILY,
    //         align: 'center',
    //         color: "#" + GlobalConfig.FONT_COLOR.toString(16)
    //     }).setOrigin(0.5, 0.5);
    //     ///
    //     this.betFoldButton()
    //     this.addUSD(1)
    // }

    ///

setBottomPart2() {

         // add button opart
         var enterRect = this.add.image( 1050,875,
            TextureKeys.Right).setOrigin(0, 0);

        var t=this.add.text(
            enterRect.x +210,//-(bgPlusMinus.width/2),
            enterRect.y+35,//-(bgPlusMinus.height/2),
            'BET SIZE', {
            fontSize: '16px',
            fontFamily: GlobalConfig.FONT_FAMILY,
            align: 'center',
            // fixedWidth:58,
            wordWrap: { width: 90, useAdvancedWrap: true },
            color: "#" + GlobalConfig.FONT_COLOR.toString(16)
        }).setOrigin(0.5, 0.5);
        this.txtPlusMinusAmount = this.add.text(
            t.x,//-(bgPlusMinus.width/2),
            t.y+60,//-(bgPlusMinus.height/2),
            '10.0', {
            fontSize: '40px',
            fontStyle:'bold',
            fontFamily: GlobalConfig.FONT_FAMILY,
            align: 'center',
            // fixedWidth:58,
            wordWrap: { width: 90, useAdvancedWrap: true },
            color: "#" + GlobalConfig.FONT_COLOR.toString(16)
        }).setOrigin(0.5, 0.5);

        //
        var add = this.add.image(
            this.txtPlusMinusAmount.x+110,//-(bgPlusMinus.width/2),
            this.txtPlusMinusAmount.y-5,//-(bgPlusMinus.height/2),
            TextureKeys.Plus,

        ).setOrigin(0.5,0.5).setInteractive().on('pointerdown',
            () => {
                add.setTint(GlobalConfig.BUTTON_TINT)
                this.addUSD(1)
            });
        add.on('pointerup',
            () => {
                add.clearTint();
            }
        )
        //
        var minus = this.add.image(
            this.txtPlusMinusAmount.x-110,//-(bgPlusMinus.width/2),
            this.txtPlusMinusAmount.y-5,//-(bgPlusMinus.height/2),
            TextureKeys.Minus,
        ).setOrigin(0.5, 0.5).setInteractive().on('pointerdown',
            () => {
                minus.setTint(GlobalConfig.BUTTON_TINT)
                this.addUSD(-1)
            });
        
        minus.setDisplaySize(minus.width*GlobalConfig.SIZE_MULTI, minus.height*GlobalConfig.SIZE_MULTI)
        minus.on('pointerup',
            () => {
                minus.clearTint();
            }
        )
        this.allButtons.push(add)
        this.allButtons.push(minus)
        var add1 = this.add.image(
            enterRect.x +430,
            enterRect.y +40,
            TextureKeys.BetxBtn1to50).setInteractive().on('pointerdown',
                () => {
                    add1.setTintFill(GlobalConfig.BUTTON_TINT)
                    this.addUSD(1)
                });
        add1.on('pointerup',
            () => {
                add1.clearTint();
            }
        )
        this.allButtons.push(add1)
      
        this.add.text(
            add1.x,//-(bgPlusMinus.width/2),
            add1.y,//-(bgPlusMinus.height/2),
            '1', {
            fontSize: '20px',
            fontStyle:'bold',
            fontFamily: GlobalConfig.FONT_FAMILY,
            align: 'center',
            color: "#" + GlobalConfig.FONT_COLOR.toString(16)
        }).setOrigin(0.5, 0.5);
        var add2 = this.add.image(
            add1.x,
            add1.y+60,
            TextureKeys.BetxBtn1to50).setInteractive().on('pointerdown',
                () => {
                    add2.setTintFill(GlobalConfig.BUTTON_TINT)
                    this.addUSD(10)
                });
                add2.setDisplaySize(add2.width*GlobalConfig.SIZE_MULTI,add2.height*GlobalConfig.SIZE_MULTI)
                add2.on('pointerup',
            () => {
                add2.clearTint();
            }
        )
        this.allButtons.push(add2)

        this.add.text(
            add2.x,//-(bgPlusMinus.width/2),
            add2.y,//-(bgPlusMinus.height/2),
            '10', {
                fontSize: '20px',
                fontStyle:'bold',
                fontFamily: GlobalConfig.FONT_FAMILY,
            align: 'center',
            color: "#" + GlobalConfig.FONT_COLOR.toString(16)
        }).setOrigin(0.5, 0.5);

        var add5 = this.add.image(
            add1.x+80,
            add1.y,
            TextureKeys.BetxBtn1to50).setInteractive().on('pointerdown',
                () => {
                    add5.setTintFill(GlobalConfig.BUTTON_TINT)
                    this.addUSD(5)
                });
                add5.setDisplaySize(add5.width*GlobalConfig.SIZE_MULTI,add5.height*GlobalConfig.SIZE_MULTI)
                add5.on('pointerup',
            () => {
                add5.clearTint();
            }
        )
        this.allButtons.push(add5)


        this.add.text(
            add5.x,//-(bgPlusMinus.width/2),
            add5.y,//-(bgPlusMinus.height/2),
            '5', {
                fontSize: '20px',
                fontStyle:'bold',
                fontFamily: GlobalConfig.FONT_FAMILY,
            align: 'center',
            color: "#" + GlobalConfig.FONT_COLOR.toString(16)
        }).setOrigin(0.5, 0.5);
        var add10 = this.add.image(
            add5.x,
            add5.y+60,
            TextureKeys.BetxBtn1to50).setInteractive().on('pointerdown',
                () => {
                    add10.setTintFill(GlobalConfig.BUTTON_TINT)
                    this.addUSD(50)
                });
                add10.setDisplaySize(add10.width*GlobalConfig.SIZE_MULTI,add10.height*GlobalConfig.SIZE_MULTI)
                add10.on('pointerup',
            () => {
                add10.clearTint();
            }
        )
        
        this.allButtons.push(add10)
        this.add.text(
            add10.x,//-(bgPlusMinus.width/2),
            add10.y,//-(bgPlusMinus.height/2),
            '50', {
                fontSize: '20px',
                fontStyle:'bold',
                fontFamily: GlobalConfig.FONT_FAMILY,
            align: 'center',
            color: "#" + GlobalConfig.FONT_COLOR.toString(16)
        }).setOrigin(0.5, 0.5);
        ///

        // this.txtBetxGreen = this.add.text(
        //     enterRect.x,//-(bgPlusMinus.width/2),
        //     enterRect.y,//-(bgPlusMinus.height/2),
        //     'BETX\n1 USD', {
        //     fontSize: '18px',
        //     fontFamily: GlobalConfig.FONT_FAMILY,
        //     align: 'center',
        //     color: "#" +  GlobalConfig.FONT_COLOR.toString(16)
        // }).setOrigin(0.5, 0.5);

        var singleplay = this.add.image(
            860,
            850,
            TextureKeys.SimplePlay
        ).setOrigin(0,0).setInteractive().on('pointerdown',
            () => {
                singleplay.setTint(GlobalConfig.BUTTON_TINT)
                if(!this.firstBet)
                {
                    this.startBet=this.betAmount;
                    this.maxBet=this.startBet*20 + this.startBet;
                    console.log("start bet "+this.startBet)
                    console.log("max bet "+this.maxBet)
                    this.gameScene.openFirst3Card()
                    this.firstBet=true;
                }
                else
                {
                    // var minbet;
                    // minbet=this.startBet*20 + this.startBet;
                    // if(this.betAmount>=minbet)
                    {
                        this.gameScene.StartGame()
                        this.disableButtons()
                        // this.txtPlusMinusAmount.setText(minbet)
                        // this.betAmount=minbet;
                        // this.txtBetxGreen.setText(`BET\n$${this.betAmount}`)
                    }
                    // else
                    // {
                    //     this.gameScene.txtPopx20.setText("REQUIRE MINIMUM BET "+minbet +" USD")
                    //     this.gameScene.showBetPop()
                    //     return;
                    // }
                    
                }
                this.coinHave-=this.betAmount;
                this.totalBet+=this.betAmount;
                // this.disableButtons()this.coinHave-=this.betAmount;
                    this.setUSDTopBar()
                    this.setUSD()
                    this.gameSt=true;
                // this.gameStart(false)
            });
        singleplay.setDisplaySize(singleplay.width*GlobalConfig.SIZE_MULTI,singleplay.height*GlobalConfig.SIZE_MULTI)
        singleplay.on('pointerup',
            () => {
                singleplay.clearTint();
            }
        )

      
        this.allButtons.push(singleplay)
        this.txtBetxGreen = this.add.text(
            singleplay.x+100,//-(bgPlusMinus.width/2),
            singleplay.y+100,//-(bgPlusMinus.height/2),
            'BET\n$1', {
            fontSize: '35px',
            fontStyle:'bold',
            fontFamily: GlobalConfig.FONT_FAMILY,
            align: 'center',
            color: "#" + GlobalConfig.FONT_COLOR.toString(16)
        }).setOrigin(0.5, 0.5)
        this.playAginBtn=this.add.image(
            860,
            850,
            TextureKeys.PlayAgin
        ).setOrigin(0,0).setInteractive().on('pointerdown',
            () => {
                this.playAginBtn.setTint(GlobalConfig.BUTTON_TINT)
                this.restartGame()
                // this.gameStart(false)
            });

        this.playAginBtn.setVisible(false)
        // game control button

        var greenBox = this.add.image(
            290,
            enterRect.y,
            TextureKeys.Left).setOrigin(0,0);
            greenBox.setDisplaySize(greenBox.width*GlobalConfig.SIZE_MULTI,greenBox.height*GlobalConfig.SIZE_MULTI);
        var homeBtn= this.add.image(
            greenBox.x+115,
            greenBox.y+115,
            TextureKeys.HomeBtn
        ).setOrigin(1,1)
        homeBtn.setDisplaySize(homeBtn.width*GlobalConfig.SIZE_MULTI,homeBtn.height*GlobalConfig.SIZE_MULTI)
        // var greenboxButton = new RoundRectangle(this, this.cameras.main.width - 60, this.cameras.main.height - 15,
        //     250, 100,
        //     25,
        //     GlobalConfig.BUTTON_COLOR)
        //     .setOrigin(1, 1);
        // this.add.existing(greenboxButton);

        

        this.autoplayBtn = this.add.image(
            742.98,
            greenBox.y,
            TextureKeys.AutoPlay
        ).setOrigin(0, 0).setInteractive().on('pointerdown',
            () => {
                // if(!this.gameSt)
                // {
                //     return;
                // }

                // this.autoplayBtn.setTint(GlobalConfig.BUTTON_TINT)
                // if(this.isAutoPlay())
                // {
                //     this.SetAutoPlay(false);
                // }
                // else
                // {
                //     this.SetAutoPlay(true);
                // }
                this.autoplayBtn.disableInteractive()
                this.autoplayBtn.setTexture(TextureKeys.AutoPlayU)
                this.disableButtons()
                this.gameScene.Fold()
            });
            this.autoplayBtn.on('pointerup',
            () => {
                this.autoplayBtn.clearTint();
            }
        )
        this.autoplayBtn.setDisplaySize(this.autoplayBtn.width*GlobalConfig.SIZE_MULTI,this.autoplayBtn.height*GlobalConfig.SIZE_MULTI)
        // this.allButtons.push(autoplay)
        this.add.text(
            this.autoplayBtn.x+60,//-(bgPlusMinus.width/2),
            this.autoplayBtn.y+35,//-(bgPlusMinus.height/2),
            'FOLD', {
            fontSize: '18px',
            fontStyle:'bold',
            fontFamily: GlobalConfig.FONT_FAMILY,
            align: 'center',
            // fixedWidth:58,
            wordWrap: { width: 58, useAdvancedWrap: true },
            color: "#" + GlobalConfig.FONT_COLOR.toString(16)
        }).setOrigin(0.5, 0.5);

        this.txtMoney = this.add.text(
            greenBox.x+300,
            greenBox.y+(greenBox.height/2)+20, 
            '$12000', {
            fontSize: '40px',
            fontStyle:'bold',
            align:'center',
            fontFamily: GlobalConfig.FONT_FAMILY,
            wordWrap: { width: 200, useAdvancedWrap: true },
            color: "#" + GlobalConfig.FONT_COLOR.toString(16)
        }).setOrigin(0.5,0.5);
        this.add.text(
            this.txtMoney.x,//-(bgPlusMinus.width/2),
            this.txtMoney.y-55,//-(bgPlusMinus.height/2),
            'AVAILABLE USD', {
            fontSize: '17px',
            fontFamily: GlobalConfig.FONT_FAMILY,
            align: 'center',
            // fixedWidth:58,
            // wordWrap: { width: 70, useAdvancedWrap: true },
            color: "#" + GlobalConfig.FONT_COLOR.toString(16)
        }).setOrigin(0.5, 0.5);
        this.addUSD(1)
        
    }


    ///
    betFoldButton()
    {
        var greenbtn = this.add.image(
            this.scale.width/2,
            this.scale.height-90,
            TextureKeys.GreenBtn).setInteractive().on('pointerdown',
                () => {
                    greenbtn.setTint(GlobalConfig.RECT_TINT)
                    this.disableButtons()
                    this.coinHave-=this.betAmount;
                    this.setUSDTopBar()
                    this.setUSD()
                    this.gameScene.StartGame()
                }).setScale(0.2);
        greenbtn.on('pointerup',
            () => {

                greenbtn.clearTint();
            }
        ).setOrigin(0.5,1)
        this.txtGreenBet=this.add.text(
            greenbtn.x,
            greenbtn.y-18,
            'Bet 1.0 USD', {
            fontSize: "20px",
            fontFamily: GlobalConfig.FONT_FAMILY,
            align: 'center',
            color: "#" + GlobalConfig.FONT_COLOR.toString(16)
        }).setOrigin(0.5,1);

        this.allButtons.push(greenbtn)
        var redBtn = this.add.image(
            greenbtn.x,
            greenbtn.y+70,
            TextureKeys.RedBtn).setInteractive().on('pointerdown',
                () => {
                    redBtn.setTint(GlobalConfig.RECT_TINT)
                    redBtn.disableInteractive()
                    this.disableButtons()
                    this.gameScene.Fold()

                }).setScale(0.2);
        redBtn.on('pointerup',
            () => {
                redBtn.clearTint();
            }
        ).setOrigin(0.5,1)
        this.add.text(
            redBtn.x,
            redBtn.y-18,
            'FOLD', {
            fontSize: "20px",
            fontFamily: GlobalConfig.FONT_FAMILY,
            align: 'center',
            color: "#" + GlobalConfig.FONT_COLOR.toString(16)
        }).setOrigin(0.5,1);
    }

    public gameStart(autoPlay: Boolean) {
        this.coinHave-=this.betAmount;
        this.setUSDTopBar()
        this.setLastBet(this.betAmount);
        this.setUSD()
    }


    public addUSD(add: number) {
        if (this.betAmount + add < 1) {
            return;
        }
        else if (this.betAmount + add > this.coinHave) {
            this.betAmount = this.coinHave;
        }
        else if(this.firstBet&& this.betAmount + add > this.maxBet)
        {
            this.betAmount = this.maxBet;
        }
        else {
            this.betAmount += add;
        }
        this.txtPlusMinusAmount?.setText(this.betAmount)
        this.txtBetxGreen?.setText(`BET\n$${this.betAmount}`)
    }

    // prefs data start

    lastWin(): number
    {
        var defaultBet=-1;
        return parseFloat(localStorage.getItem('lastwin') || defaultBet.toString())
    }

    setLastWin(val : number)
    {
        localStorage.setItem('lastwin', val.toString())
    }

    public lastBet(): number
    {
        var defaultBet=1;
        defaultBet= parseInt(localStorage.getItem('lastbet') || defaultBet.toString());
        return Phaser.Math.RoundTo(defaultBet)
    }
    public setLastBet(val : number)
    {
        localStorage.setItem('lastbet', val.toString())
    }
    public getUSD(): number {
        return parseFloat(localStorage.getItem('USDHave') || GlobalConfig.START_USD.toString());
    }
    setUSD() {
        localStorage.setItem('USDHave', this.coinHave.toString())
    }
    // prefs data end


    // top bar start

    setTopBar() {
        var rect = new RoundRectangle(this, this.cameras.main.width / 2, 35, this.cameras.main.width - 50, 50, 25, GlobalConfig.SECONDARY_COLOR);
        this.add.existing(rect);
        var sizer = new Sizer(this, {
            orientation: 'horizontal',
            x: this.cameras.main.width / 2,
            y: 35,
            width: this.cameras.main.width - 50,
        });
        var text = this.add.text(0, 0, GlobalConfig.GAME_NAME, {
            fontSize: GlobalConfig.FONT_SIZE_TITLE,
            fontFamily: GlobalConfig.FONT_FAMILY,
            color: "#" + GlobalConfig.FONT_COLOR.toString(16)
        });

        this.txtMoney = this.add.text(0, 0, 'USD 12000', {
            fontSize: GlobalConfig.FONT_SIZE_TITLE,
            fontFamily: GlobalConfig.FONT_FAMILY,
            color: "#" + GlobalConfig.FONT_COLOR.toString(16)
        });
        var buttonBackground = new RoundRectangle(
            this,
            0,
            0,
            100,
            20,
            20,
            GlobalConfig.BACKGROUND_COLOR
        );
        this.add.existing(buttonBackground);
        this.lastWinTxt= this.add.text(0, 0, '', {
            fontSize: '20px',
            fontFamily: GlobalConfig.FONT_FAMILY,
            color: "#" + GlobalConfig.FONT_COLOR.toString(16),
            wordWrap:{width:300}
        });
        var button = new Label(this, {
            background: buttonBackground,
            icon: this.add.image(0, 0, IconKey.home).setDisplaySize(25, 25),
            space: {
                left: 10,
                right: 10,
                top: 10,
                bottom: 10
            }
        }).setInteractive()
            .on('pointerdown', function () {
                console.log('Button clicked!');
            });

        sizer.insert(0, text, { padding: { left: 40 } });
        sizer.insert(1,this.lastWinTxt,{padding:{left:50}})
        sizer.insertSpace(2);
        sizer.insert(3, this.txtMoney, { padding: { right: 50 } });
        sizer.insert(4, button, { padding: { right: 20 } });
        sizer.layout();
        this.add.existing(sizer);


    }

    setUSDTopBar() {
        
        // console.log("called "+ this.coinHave)
        this.txtMoney?.setText('$' + this.coinHave.toFixed(2));
    }
    // top bar end


}